import { Toaster as Sonner, toast } from "sonner";
import { useAdminDark } from "@/lib/adminTheme";
import { isNative } from "@/lib/platform";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  // Folgt dem Admin-Dark-Schalter (vorher: next-themes ohne Provider → immer "system").
  // Außerhalb von /admin ist die html-Klasse nie gesetzt, dort bleibt es hell.
  const adminDark = useAdminDark();
  const theme: ToasterProps["theme"] =
    adminDark && document.documentElement.classList.contains("dark") ? "dark" : "light";

  // App: Meldungen oben statt über der Tab-Leiste, mit Schließen-Knopf. Auf dem iPhone blieb
  // eine Meldung nach dem Antippen stehen (Sonner pausiert den Timer, solange es die Liste für
  // „berührt“ hält) und verdeckte Buchen/Termine (Tester-Feedback 19.10.2026).
  const native = isNative();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      {...(native ? { position: "top-center" as const, closeButton: true, offset: "calc(env(safe-area-inset-top, 0px) + 8px)" } : {})}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
